/** @module Auth0LocalizedError */

class Auth0LocalizedError extends Error {
  /**
   * @constructor
   * @description An extension of basic Error() that uses language pack keys
   * @extends Error
   * @param {string} msg - The details of the error
   * @param {string} key - The translation key used for error lookup in {@link module:src/auth0-language-packs}
   * @param {int} [code] - The unique code representing the error or class of error
   * @param {string} [idpName] - The name of the Identity Provider to which the error is related (if appropriate)
   */
  constructor(msg, key, code, idpName) {
    super(msg);
    this.code = code;
    this.key = key;
    this.idpName = idpName;
    this.details = msg;
    this.name = Auth0LocalizedError.name;
  }
}

export default Auth0LocalizedError;
